import ModalAlert from '../ModalAlert';
import { ModalConfirmProps } from '../types/modal';

export default function ModalConfirm({
  isOpen,
  title,
  description,
  buttonConfirmText,
  buttonCancelText,
  alertType,
  onClickConfirm,
  onClickCancel,
  handleClose,
}: ModalConfirmProps) {
  const handleClickCancel = () => {
    if (onClickCancel) {
      onClickCancel();
    }

    handleClose();
  };
  return (
    <ModalAlert
      isOpen={isOpen}
      handleClose={handleClose}
      title={title}
      description={description}
      alertType={alertType}
      onClickConfirm={onClickConfirm}
      buttonConfirmText={buttonConfirmText}
      buttons={[
        {
          buttonText: buttonCancelText ?? '취소',
          buttonType: 'default',
          onClick: handleClickCancel,
        },
      ]}
    />
  );
}
